import _ from "lodash";
import h from "../../core/createElement";
import { switchable_element } from "../../utils"
import ReportCard from "./report_card";
import report_service from "../../service/report_service";
import Pagination from "../pagination";
import Spinner from "../spinner";
import EmptyMsgBox from "../empty_msg";


export default function ReportList({ shared = {}, name = "report_list", onCardHighlight, onCardDismissHighlight, cardClick }) {
    let search = {}, page = 1;

    const
        ept_msg = <EmptyMsgBox text="Nenhum relatório encontrado" />,
        loading = switchable_element(<Spinner />),
        list = switchable_element(h('section', { class: "full-size" }, ept_msg));

    shared[name] = {
        fetch_report: async (_search, _page) => {
            try {
                loading.show();

                if (_page) page = _page;
                if (_search) search = _search;

                const { data } = await report_service.get({ ...search, page, group_id: shared.group_id });

                list.switch(
                    <section class="full-size">
                        {data.data.length ?
                            _.map(data.data, e => (
                                <ReportCard
                                    onHighlight={onCardHighlight}
                                    onDismissHighlight={onCardDismissHighlight}
                                    data={e}
                                    onClick={cardClick}
                                />
                            ))
                            :
                            ept_msg
                        }
                        <section class="float-pagination">
                            <Pagination current={data.current_page} last={data.total_pages} callback={e => shared[name].fetch_report(null, e.page)} />
                        </section>
                    </section>
                );

                loading.hide();
            } catch (e) {
                loading.hide();
            }
        },
        dismiss_all_cards_highlights() {
            list.current().querySelectorAll("article.highlighted-in-overlay").forEach(e => { e.classList.remove("highlighted-in-overlay") });
        },
        highlight_card_by_id(id) {
            list.current().querySelector('#report_card_' + id)?.classList.add('highlighted-in-overlay')
        }
    };
    return [list.current(), loading.marker()];
};